var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandSquaredYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9343 1.5C21.3504 1.5 22.5 2.64967 22.5 4.06569V19.9343C22.5 21.3503 21.3503 22.5 19.9343 22.5H4.06569C2.64967 22.5 1.5 21.3503 1.5 19.9343V4.06569C1.5 2.64967 2.64963 1.5 4.06569 1.5H19.9343V1.5ZM19.0743 8.70357C18.9046 8.06828 18.4043 7.56797 17.769 7.39821C16.6173 7.08961 12 7.08961 12 7.08961C12 7.08961 7.38267 7.08961 6.23103 7.39821C5.59586 7.56797 5.09547 8.06828 4.92567 8.70357C4.61719 9.85509 4.61719 12.2577 4.61719 12.2577C4.61719 12.2577 4.61719 14.6602 4.92567 15.8116C5.09547 16.4469 5.59586 16.9473 6.23103 17.1171C7.38267 17.4255 12 17.4255 12 17.4255C12 17.4255 16.6173 17.4255 17.769 17.1171C18.4043 16.9473 18.9046 16.4469 19.0743 15.8116C19.3828 14.6602 19.3828 12.2577 19.3828 12.2577C19.3828 12.2577 19.3828 9.85509 19.0743 8.70357ZM10.5234 14.4725V10.0428L14.3595 12.2577L10.5234 14.4725Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSquaredYoutube);
export default __webpack_public_path__ + "static/media/brand_squared_youtube.1503e07424b5550704935dd0216cd603.svg";
export { ForwardRef as ReactComponent };